<template>
  <div class="box">
    <div class="head">
      <Header></Header>
    </div>
    <!-- 文章内容 -->
    <div class="div">
      <div class="ThereIsNo">
        <div class="QRcode">
          <img
            src="../../../assets/images/dynamicInformation/Information/QRcode.png"
            alt=""
          />
          <p>
            微信扫一扫 <br />
            关注该公众号
          </p>
        </div>
      </div>
      <div class="essayOne">
        <h2>“环保管家”如何帮政府和企业降低被问责和处罚风险？</h2>
        <div class="time">
          <a href="#">环保大讲坛</a> &nbsp; 2022-04-18 17:32
        </div>
        <div class="texts">
          <!-- ----------------------------------------------------- -->
          <p>
            环保管理是一项复杂工作，随着环保管控不断升级，要求越来越高，“专业人做专业事”的理念不
            断深入，越来越多的环境管理部门和排污企业 聘请“环保管家”进行管理。
          </p>
          <p>
            做好一家公司的“环保管家”工作容易，做好几十家几百家甚至上千家企业的“环保管家”工作则
            十分不容易。传统的服务方式，需要投入巨大的人力、时间进行现场检查工作，早期一个县/园
            区的环保管家服务费用高达数百万，但随着市场竞争越来越激烈，现在的环保管家服务价格持续
            走低，出现某市1000多家的环保管家政府采购费用不足50万，服务质量大大降低。“环保管家”的
            效果微乎其微，多数以走过场结束。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img000.png"
            alt=""
          />
          <p style="color: #000; font-weight: 700">
            如何提高环保管家的专业程度和工作效率，是此项工作面临的难题。
          </p>
          <p>
            北京中泽宇华环境科技有限公司根据自身多年从事环保管理的经验，研发智慧环保综合管控系统，
            能快速高效地帮助环保管理部门和排污企业提高环保管理水平，减少环保局被约谈问责、排污企业被环境处罚的风险。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img001.png"
            alt=""
          />
          <h3
            style="
              color: #fff;
              font-size: 17px;
              background-color: #00d100;
              width: 90px;
              font-weight: 500;
            "
          >
            系统特点：
          </h3>
          <h3 style="color: #222222; font-size: 17px; font-weight: 700">
            1、一套数据，政—企互动管理
          </h3>
          <p>
            管理端、企业端，穿透式管理，企业可以随时了解自己存在的问题，及时处理，企业数据同步至
            管理端，方便跟踪和指导，响应国家政策要求“非必要不入厂检查，干扰企业生产”，实现高效的远程管理。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img002.png"
            alt=""
            style="margin-bottom: 20px"
          />
          <i style="color: #222222; font-size: 17px; font-weight: 700"
            >2、人找数据 & 数据找人</i
          >
          <p>
            系统内置13大项预警报警模块，涉及内容包括环评、排污许可、自行监测、在线监测、视频等，多
            数据联动分析，充分挖掘数据价值，从人找数据变为数据找人，将传统的判断数据是否超标，扩展至判断：<br />
            （1）是否按要求执行停限产<br />
            （2）在线设备是否有造假嫌疑<br />
            （3）是否按要求执行排污许可 <br />
            （4）危废是否存在非法转移<br />
            （5）企业环保手续是否齐全（环评、应急预案）
          </p>
          <p>
            系统自动报警，将传统的人找数据升级至数据异常自动报警，数据找人，提高管理的针对性和效率。
            <br />
            应用案例：在线造假
          </p>
          <p>系统报警——在线数据运行异常</p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img003.png"
            alt=""
          />
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img004.png"
            alt=""
          />
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img005.png"
            alt=""
          />
          <h3 style="color: #222222; font-size: 17px; font-weight: 700">
            3、多维度数据可视化展示
          </h3>
          <p>
            系统设置水环境质量、固废跟踪、应急指挥等专项大屏，多维度全方位展示环境信息。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img006.png"
            alt=""
          />
          <div
            style="
              color: #222222;
              font-size: 17px;
              width: 100%;
              text-align: center;
            "
          >
            数据大屏
          </div>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img007.png"
            alt=""
          />
          <div
            style="
              color: #222222;
              font-size: 17px;
              width: 100%;
              text-align: center;
            "
          >
            大气专项——挂图作战应急指挥
          </div>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img008.png"
            alt=""
          />
          <div
            style="
              color: #222222;
              font-size: 17px;
              width: 100%;
              text-align: center;
            "
          >
            预警报警中心
          </div>
          <h3 style="color: #222222; font-size: 17px; font-weight: 700">
            4、APP、短信、异常数据实时提醒
          </h3>
          <div style="display: flex; width: 100%">
            <img
              src="../../../assets/images/dynamicInformation/Information/psge3/img009.png"
              alt=""
              style="width: 50%"
            />
            <img
              src="../../../assets/images/dynamicInformation/Information/psge3/img010.png"
              alt=""
              style="width: 50%"
            />
          </div>
          <h3 style="color: #222222; font-size: 17px; font-weight: 700">
            5、区域污染因子库
          </h3>
          <p>
            一个区域或服务的企业属于行业、各企业污染因子能在系统自动统计汇总，为后续提供政府环保决策、业务拓展提供数据支持，比如：<br />
            （1）区域污染物减排指标量化、减排潜力分析<br />
            （2）为走航监测提供基础数据库<br />
            （3）中小企业小批量危废统一转移<br />
            应用案例：
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img011.png"
            alt=""
          />
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img012.png"
            alt=""
          />
          <h3 style="color: #222222; font-size: 17px; font-weight: 700">
            6、事务跟踪统计
          </h3>
          <p>区域各企业设计环保整改项目跟踪统计，落实环保整改</p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img013.png"
            alt=""
          />
          <h3 style="color: #222222; font-size: 17px; font-weight: 700">
            7、环保档案库
          </h3>
          <p>
            软件按环保10大类档案进行分类存储，支持文件在线查看、下载、管理，一键搜索档案的文号、存放位置等。避免资料在交接、转移过程中发生遗失。
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img014.png"
            alt=""
          />

          <h3 style="color: #222222; font-size: 17px; font-weight: 700">
            8、标准化管理流程
          </h3>
          <p>
            通过软件实现“环保管家”标准化管理，不论是第三方公司还是政府管理部门都能通过软件进行管理，
            快速找到企业在生产过程易产生不合规事项，并处理，减少被处罚的风险。信息平台不但能提升环保
            管家服务的附加值，还能让员工快速进入服务角色，明确去企业做什么，从而做好企业服务。
          </p>

          <h3 style="color: #222222; font-size: 17px; font-weight: 700">
            9、“一企一策”电子化闭环管理
          </h3>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge3/img015.png"
            alt=""
          />

          <!-- ---------------------------------------------------------------------------- -->

          <p style="text-indent: 2em">
            以上仅列出我司智慧环保管控平台部分功能，欢迎来电咨询详情。 <br />
            北京中泽宇华环境科技有限公司致力于开发灵活、实用、易操作的环保软件，同时也提供环保软件定制化服务，助力企业、环保管理部门信息化、数字化升级。
            中泽宇华专注环保管理软件开发，因为专注，所以专业，欢迎咨询！<br />
            地址：北京市大兴区西红门兴创国际中心S座809室 <br />
            武汉市经济开发区东合中心E座506室<br />
            联系人：方经理 联系电话：18510508157（微信同号） <br />
            联系人：刘经理 联系电话：010-80251293 、13407191262（微信同号）
            <br />
          </p>
          <img
            src="../../../assets/images/dynamicInformation/Information/psge2/img018.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="foot">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/views/header/Header.vue";
import Footer from "@/views/footer/Footer.vue";
export default {
  components: { Header, Footer },

  data() {
    return {};
  },
  created() {
    this.$store.state.menu = 4;
  },
};
</script>
<style
  lang="scss"
  src="../../../assets/css/dynamicInformation/Information.scss"
></style>
